import { RadioButtonGroup, RadioButton } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { que2bValueProps } from '../../SPSSPurchaseAdvisorSelfAssessment';
import { segmentsTracking } from 'src/common/lib/tracker';
import '../../../../../common/style/common.scss';
import { feature } from 'src/apps/spss-purchase-advisor-self-assessment/constants/default';
import {
  convertToString,
  TranslationFunction,
} from 'src/common/hooks/widgets/useTranslation';
type Step1Props = {
  pathSelected: string;
  que1Value: string;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  setQue2AValue: React.Dispatch<React.SetStateAction<string>>;
  setQue2BValue: React.Dispatch<React.SetStateAction<que2bValueProps>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  isRequired: boolean;
  setStatsPkg: React.Dispatch<React.SetStateAction<string>>;
  useTranslation: TranslationFunction;
};

const Step1 = ({
  pathSelected,
  que1Value,
  setQue1Value,
  setQue2AValue,
  setQue2BValue,
  setIsRequired,
  setStatsPkg,
  useTranslation,
}: Step1Props) => {
  const handleClick = (value: string) => {
    setQue1Value(value);
    setIsRequired(false);
    setQue2AValue('');
    setStatsPkg('');
    setQue2BValue({
      options: {
        Q3BA1: {
          value: '',
          checked: false,
        },
        Q3BA2: {
          value: '',
          checked: false,
        },
        Q3BA3: {
          value: '',
          checked: false,
        },
        Q3BA4: {
          value: '',
          checked: false,
        },
      },
    });
    segmentsTracking('CTA Clicked', {
      pageTitle: 'SPSS Purchasing Advisor Self Assessment',
      object: 'SPSS Purchasing Advisor Self Assessment page',
      resultValue: 'CTA clicked',
      CTA: 'Q1 answer selection',
      location: `${pathSelected} Assessment`,
      action: value,
      field: '',
    });
  };

  useEffect(() => {
    if (!que1Value) {
      setIsRequired(true);
    } else {
      setIsRequired(false);
    }
  }, [que1Value]);

  return (
    <div>
      <div>
        <div className="page_heading_3 padding_8">
          {useTranslation('ques1_text')}
        </div>
        <RadioButtonGroup
          name="Q1-feature"
          valueSelected={que1Value}
          orientation="vertical"
          className="spss-mar5"
        >
          <RadioButton
            labelText={convertToString(useTranslation('feat_ans1', true))}
            value={feature.opt1}
            id="Q1A1"
            onClick={() => handleClick(feature.opt1)}
          />
          <RadioButton
            labelText={convertToString(useTranslation('feat_ans2', true))}
            value={feature.opt2}
            className="spss-mar2"
            id="Q1A2"
            onClick={() => handleClick(feature.opt2)}
          />
          <RadioButton
            labelText={convertToString(useTranslation('feat_ans3', true))}
            value={feature.opt3}
            id="Q1A3"
            className="spss-mar2"
            onClick={() => handleClick(feature.opt3)}
          />
          <RadioButton
            labelText={convertToString(useTranslation('feat_ans4', true))}
            value={feature.opt4}
            id="Q1A4"
            className="spss-mar2"
            onClick={() => handleClick(feature.opt4)}
          />
          <RadioButton
            labelText={convertToString(useTranslation('feat_ans5', true))}
            value={feature.opt5}
            id="Q1A5"
            className="spss-mar2"
            onClick={() => handleClick(feature.opt5)}
          />
          <RadioButton
            labelText={convertToString(useTranslation('feat_ans6', true))}
            value={feature.opt6}
            id="Q1A6"
            className="spss-mar2"
            onClick={() => handleClick(feature.opt6)}
          />
        </RadioButtonGroup>
      </div>
    </div>
  );
};

export default Step1;
